import Routes from '@tabeeb/routes'

export const getAvailableReportRoutes = ({
  showAllSessions,
  showAllForms,
  showPowerBIReports,
  showPowerBIProviders,
  showGeneratedReports,
}) => {
  const routes = []

  if (showAllSessions) {
    routes.push(Routes.tenantSessions)
  }

  if (showAllForms) {
    routes.push(Routes.allForms)
  }

  if (showPowerBIReports) {
    routes.push(Routes.powerBIReports)

    if (showPowerBIProviders) {
      routes.push(Routes.powerBIReportProviders)
    }
  }

  if (showGeneratedReports) {
    routes.push(Routes.generatedReports)
  }

  return routes
}

export const getFirstAvailableReportRoute = (options) => getAvailableReportRoutes(options)[0] || null
